"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initDocumentBootstrapping = exports.autoInitDocumentBootstrapping = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _throttle = _interopRequireDefault(require("lodash/fp/throttle"));
var _process = _interopRequireDefault(require("process"));
var _deviceUtils = require("./deviceUtils");
var _colorScheme = require("./colorScheme");
var _version = _interopRequireDefault(require("../version.json"));
var uikitVersion = _version["default"].version;

// Note: using import.meta.env.DEV does not work here due to backward compatibility with webpack and jest setups
var isProdEnv = function isProdEnv() {
  return _process["default"].env.NODE_ENV === 'production' || location.protocol.startsWith('https');
};
var isTestEnv = function isTestEnv() {
  return _process["default"].env.NODE_ENV === 'test';
};
var isLocalhost = function isLocalhost() {
  var _window, _window$location;
  return ((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname) === 'localhost';
};

// https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
var calcViewportUnits = function calcViewportUnits() {
  var vh = window.innerHeight * 0.01;
  return "--vh: ".concat(vh, "px");
};
var logStyled = function logStyled(log) {
  return console.log('%c%s', 'color: #697a8b;', log);
};
var printPoweredByRIO = function printPoweredByRIO() {
  logStyled('- - - - - - - - - - - - - - - - - - - - - - -');
  if (!isLocalhost() && !(0, _deviceUtils.inIframe)()) {
    logStyled("  ____  ___ ___    _   _ ___ _  _____ _____\n |  _ \\|_ _/ _ \\  | | | |_ _| |/ /_ _|_   _|\n | |_) || | | | | | | | || || ' / | |  | |\n |  _ < | | |_| | | |_| || || . \\ | |  | |\n |_| \\_\\___\\___/   \\___/|___|_|\\_\\___| |_|\n");
  }
  var message = [" Version ".concat(uikitVersion, " | https://uikit.developers.rio.cloud")];
  if (isProdEnv() && !(0, _deviceUtils.inIframe)()) {
    message.push('\n\n You are a Developer? RIO is hiring! | https://rio.cloud/en/career');
  }
  logStyled(message.join(''));
  logStyled('- - - - - - - - - - - - - - - - - - - - - -');
};
var checkForReleaseVersion = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var remoteVersionsListUrl, response, data;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (isProdEnv()) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          remoteVersionsListUrl = 'https://uikit.developers.rio.cloud/versionsList.json';
          _context.prev = 3;
          _context.next = 6;
          return fetch(remoteVersionsListUrl, {
            method: 'get'
          });
        case 6:
          response = _context.sent;
          _context.next = 9;
          return response.json();
        case 9:
          data = _context.sent;
          if (data.latest_release !== uikitVersion) {
            console.log("\uD83C\uDD95 UIKIT version ".concat(data.latest_release, " is the latest released version! Your are using ").concat(uikitVersion));
          }
          _context.next = 16;
          break;
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](3);
          // console.warn(error);
          console.warn("Faild to fetch versionsList from ".concat(remoteVersionsListUrl));
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 13]]);
  }));
  return function checkForReleaseVersion() {
    return _ref.apply(this, arguments);
  };
}();
var checkMatchingUkitVersions = function checkMatchingUkitVersions() {
  Array.from(document.querySelectorAll('link[rel="stylesheet"]')).forEach(function (cssLink) {
    var href = cssLink.href;
    if (href.includes('uikit.developers.rio.cloud')) {
      var _URL$pathname$split = new URL(href).pathname.split('/'),
        _URL$pathname$split2 = (0, _slicedToArray2["default"])(_URL$pathname$split, 2),
        uikitVersionCSS = _URL$pathname$split2[1];
      if (!href.includes(uikitVersion)) {
        console.warn(['You are using different UIKIT JS and CSS versions.\n', "Your current JS version is ".concat(uikitVersion, " and "), "your current CSS version is ".concat(uikitVersionCSS, ".\n"), 'If this is not on purpose, please fix it. Otherwise, this may lead to UI bugs.'].join(''));
      }
    } else if (href.includes('cdn.rio.cloud/libs/rio-uikit')) {
      console.error('You are still using an old "cdn.rio.cloud" css import. This will lead to mayor UI bugs!');
    }
  });
};
var initDocumentBootstrapping = function initDocumentBootstrapping(document) {
  if (!document || !document.documentElement) {
    return;
  }
  if (!isTestEnv()) {
    console.group('UIKIT');
    console.log("Init document bootstrapping for ".concat(document.location.href));
  }
  var html = document.documentElement;
  var setViewportUnits = function setViewportUnits() {
    return html.setAttribute('style', calcViewportUnits());
  };
  window.addEventListener('orientationchange', (0, _throttle["default"])(1000, setViewportUnits));
  window.addEventListener('resize', (0, _throttle["default"])(1000, setViewportUnits));
  setViewportUnits();
  if (!window.CSS || !window.CSS.supports || !window.CSS.supports('gap: 1px')) {
    html.classList.add('css-no-gap');
  }
  if (html && (0, _deviceUtils.inIframe)()) {
    html.classList.add('window-iframe');
  }
  if (!isTestEnv()) {
    (0, _colorScheme.getColorScheme)();
    (0, _colorScheme.listenForSchemeChange)();
    printPoweredByRIO();
    checkForReleaseVersion();
    checkMatchingUkitVersions();
    console.groupEnd('UIKIT');
  }
};
exports.initDocumentBootstrapping = initDocumentBootstrapping;
var autoInitDocumentBootstrapping = function (document) {
  return initDocumentBootstrapping(document);
}(document);
exports.autoInitDocumentBootstrapping = autoInitDocumentBootstrapping;